import './fullScreenSection.scss';
import * as React from 'react';
export const FullScreenSection = ({ className, background, foreground, side, darkenBg, mini, ...attr }) => (<div className={`full-screen-section${className ? ` ${className}` : ''}`} data-darken-bg={darkenBg} data-mini={mini} {...attr}>
    {background && <div className="full-screen-section-background">{background}</div>}

    {foreground && (<div className="full-screen-section-foreground" data-has-side-text={!!side}>
        {foreground}
      </div>)}

    {side && <div className="full-screen-section-side-text">{side}</div>}
  </div>);
FullScreenSection.defaultProps = {
    darkenBg: true,
};
export default FullScreenSection;
export const FullScreenSectionCopy = ({ children }) => (<div className="full-screen-section-copy-wrapper">
    <div className="full-screen-section-copy">{children}</div>
  </div>);
